
import { Options, mixins } from "vue-class-component";
import StoreReports from "../../service/StoreReports";
import UtilityOptions from "../../mixins/UtilityOptions";
import AutoComplete from "primevue/autocomplete";

interface IList {
  accountCode: string;
  accountId: number;
  accountName: string;
  amount: number;
  createdAt: string;
  generatedSource: string;
  id: number;
  narration: string;
  transactionId: number;
  type: string;
  updatedAt:string;
}

interface ITransaction {
  date: string;
  narration: string;
  source: string;
  debit: number;
  credit: number;
  balance: number;
}

interface Ledger {
  accountTitle:string,
  accountID:number,
  accountCode:string,
  transactions: ITransaction []
}

interface PreviousTransaction {
  accountId:number;
  totalDebit:number;
  totalCredit: number;
}

@Options({
  title: 'General Ledger',
  components: {AutoComplete},
})

export default class LedgerStatement extends mixins(UtilityOptions) {
  private lists : IList [] = [];
  private previousList : PreviousTransaction [] = [];
  private reportService;
  private resultTitle = "";
  private previousDate = "";
  private storeName = "";
  private productDialog = false;
  private loading = false;
  private home = { icon: "pi pi-home", to: "/" };
  private items = [
    { label: "Reports", to: "reports" },
    { label: "General Ledger", to: "ledger-statement" },
  ];

  private searchFilters = {
    id: "",
    date1: "",
    date2: "",
    filterType: "None",
    reportType: "Assets",
    storeType: "all_stores",
    storeID: 0,
  };

  private storeType = [
    {
      name: 'Single Store',
      value:'single_store'
    },
    {
      name: 'All Stores',
      value:'all_stores'
    }
  ];

  private reportTypes = [
    {
      name: 'Assets',
    },
    {
      name: 'Liability',
    },
    {
      name: 'Equity',
    },
    {
      name: 'Revenue',
    },
    {
      name: 'Expense',
    },
  ];

  private filterDates = [];
  private dialogTitle;
  private submitted = false;
  private filterBranch = [];

  //CALLING WHENEVER COMPONENT LOADS
  created() {
    this.reportService = new StoreReports();
  }
  
   //CALLNING AFTER CONSTRUCTOR GET CALLED
  mounted() {
    this.storeList();
    this.loadList();
  }

  //OPEN DIALOG TO ADD NEW ITEM
  openDialog() {       
    this.submitted = false;
    this.dialogTitle = "Filter Report";
    this.productDialog = true;
  }

  storeList()
  {
    this.reportService.getFilterList().then((res) => {
      this.filterBranch  = res.stores;
      this.filterDates   = res.datesList;
    });
  }
 
  // USED TO GET SEARCHED ASSOCIATE
  loadList() {
    this.loading = true;
    this.reportService.ledgerStatement(this.searchFilters).then((res) => {
        const data = this.camelizeKeys(res);
        this.resultTitle = data.resultTitle;
        this.previousDate = data.previousDate;
        this.storeName = data.storeName;
        this.lists = data.record;
        this.previousList = data.previousRecord;
        this.loading = false;
      });
    this.productDialog = false;
  }

   get filterAccounts() : IList []  {
    let copyList :IList [] = [];

    if (this.lists != null) {
      copyList = [...this.lists];
    }

    const uniqueElementsBy = (arr, fn) =>
      arr.reduce((acc, v) => {
        if (!acc.some((x) => fn(v, x))) acc.push(v);
        return acc;
      }, []);

    const list = uniqueElementsBy(
      copyList,
      (a, b) => a.accountId == b.accountId
    );

    return list;
  }

  get ledgerTransactions () : Ledger []
  {
    const ledgerList: Ledger [] = [];
    const filteredList: IList []  = [...this.filterAccounts];

      filteredList.map(a => {

        const list: IList []  = this.lists.filter(e => e.accountId == a.accountId);

        const iList : ITransaction [] = [];

        list.forEach((l,i) => {

          let debit = 0;
          let credit = 0;
          let lastBalance = 0;

          if(l.type == 'Debit')
          {
            debit = l.amount;
          }
          else
          {
            credit = l.amount;
          }

          if(iList.length > 0)
          {
            const t = iList[iList.length-1];
            lastBalance =  t.balance;
          }
          else
          {
            lastBalance = this.previousBalance(l.accountId);
          }
          

          const b = lastBalance + (debit-credit);

            const p: ITransaction = {
              date: l.createdAt,
              narration: l.narration,
              debit : debit,
              credit: credit,
              balance : b,
              source : l.generatedSource
            };

            iList.push(p);
        });

        const d = {
          accountTitle : a.accountName,
          accountCode  : a.accountCode,
          accountID    : a.accountId,
          transactions : iList
        }

        ledgerList.push(d);

      });
    
    return ledgerList;
  }

  checkForCredit(a)
  {
    let b = '';

    if(a < 0)
    {
      b = '('+this.formatAmount(Math.abs(a))+')';
    }
    else
    {
      b = this.formatAmount(a);
    }

    return b;
  }

  previousDebit(accountID)
  {
    let total = 0;
    
    const t: PreviousTransaction [] = this.previousList.filter(e => e.accountId == accountID);
    
    if(t.length > 0)
    {
      total = t[0].totalDebit;
    }

    return  total;
  }
  
  previousCredit(accountID)
  {
    let total = 0;
    
    const t: PreviousTransaction [] = this.previousList.filter(e => e.accountId == accountID);
    
    if(t.length > 0)
    {
      total = t[0].totalCredit;
    }

    return  total;
  }
  
  previousBalance(accountID)
  {
    let total = 0;
    
    const t: PreviousTransaction [] = this.previousList.filter(e => e.accountId == accountID);
    
    if(t.length > 0)
    {
      total = t[0].totalDebit -  t[0].totalCredit;
    }

    return  total;
  }

  get currency() {
    return this.store.getters.getCurrency;
  }

  clearForFilters() {
    this.searchFilters.date1 = "";
    this.searchFilters.date2 = "";
  }

  clearSearch() {
    this.searchFilters.filterType = "None";
  }
}
